import React from 'react';
import { Container, Button } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

const CoverView = ({ data }) => {
  const imageUrl = data.image ? `${data.image}/@@images/image` : null;
  const linkUrl = data.link?.[0]?.['@id']
    ? flattenToAppURL(data.link[0]['@id'])
    : null;

  return (
    <section
      className="cover-block"
      style={{
        backgroundImage: imageUrl ? `url(${imageUrl})` : undefined
      }}
    >
      <Container className="cover-content">
        <h1>{data.title}</h1>
        {data.subtitle && <p>{data.subtitle}</p>}
        {linkUrl && (
          <Button
            as="a"
            href={linkUrl}
            className="cover-block-button"
            primary
            size="large"
            content="Learn More"
          />
        )}
      </Container>
    </section>
  );
};

export default CoverView;
